import * as Bixby from '$/core';

export abstract class FeatureFlagService {
  private static baseUrl = Bixby.Constants.API_FEATUREFLAGCONTROLLER;

  public static async getFeatureFlags(): Promise<string[]> {
    const route = Bixby.API.ServerRoute.forAction(`${FeatureFlagService.baseUrl}`);
    return await Bixby.API.get(route);
  }
}
